import { Avatar } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Popover } from 'antd'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { sortTeamMembers } from '../chargeRatesUtils'

export type PopoverTeamMember = {
  id: string
  name: string
  avatarUrl?: string | null
}

type TeamMembersPopoverProps = {
  children: ReactNode
  members: PopoverTeamMember[]
}

const TeamMembersPopover = ({ children, members }: TeamMembersPopoverProps) => {
  const { t } = useTranslation()
  const sortedMembers = sortTeamMembers(members)

  return (
    <Popover
      placement="top"
      showArrow
      trigger="hover"
      arrow={{ pointAtCenter: true }}
      content={
        <ContentContainer>
          <TitleText level={2}>
            {t('RECONCILIATION_CHARGE_ASSIGNED_TEAM_MEMBERS')}
          </TitleText>
          {sortedMembers.map((member) => (
            <MemberRow key={member.id}>
              <Avatar url={member.avatarUrl ?? undefined} size={20} />
              <NameText>{member.name}</NameText>
            </MemberRow>
          ))}
        </ContentContainer>
      }
    >
      {children}
    </Popover>
  )
}

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const TitleText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`

const MemberRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const NameText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

export default TeamMembersPopover
